import{createContext}from"react";export var ReorderedColumnsContext=createContext([]);